export default {
  SET_FLOWS_DEFINITIONS(state, data) {
    state.flowsDefinitions = data;

    const definitionsUI = {};
    // ACTIONS
    definitionsUI.actions = {};
    data.blocks.definitions.actions.forEach((action) => {
      const data = {
        name: action.meta.name,
        description: action.meta.description,
        colors: action.meta.colors,
        icon: action.definition.icons,
      };
      definitionsUI.actions[action.meta.type] = data;
    });

    // LOGIC
    definitionsUI.logic = {};
    data.blocks.definitions.logic.forEach((logic) => {
      let data = {
        name: logic.meta.name,
        description: logic.meta.description,
        colors: logic.meta.colors,
        icon: logic.definition.icons,
        values: {},
      };
      if (logic.definition.elements) {
        logic.definition.elements.forEach((element) => {
          data.values[element.type] = element.values;
        });
      }
      if (logic.meta.type === 'CONREP') {
        data.values = {
          ...data.values,
          minValue: logic.definition.limits.min_time,
          maxValue: logic.definition.limits.max_time,
        };
      } else if (logic.meta.type === 'SPLIT') {
        data = {
          ...data,
          limits: logic.definition.limits,
        };
      }
      definitionsUI.logic[logic.meta.type] = data;
    });

    // TRIGGERS
    definitionsUI.triggers = {};
    data.blocks.definitions.triggers.forEach((trigger) => {
      const data = {
        name: trigger.meta.name,
        description: trigger.meta.description,
        colors: trigger.meta.colors,
        options: trigger.definition.triggers.reduce((acc, curr) => { acc[curr.type] = curr; return acc; }, {}),
        icon: trigger.definition.icons,
      };
      definitionsUI.triggers[trigger.meta.type] = data;
    });

    // TRIGGER_FREQUENCY
    definitionsUI.trigger_frequency = data.flows.params.trigger_frequency.reduce((acc, curr) => { acc[curr.type] = curr; return acc; }, {});

    state.flowsDefinitionsUI = definitionsUI;
  },
  SET_ORGANISATION_FLOWS(state, data) {
    const knownFlows = state.flows.map(flow => flow.flow_id);
    data = data.filter(flow => !knownFlows.includes(flow.flow_id));
    state.flows = [...state.flows, ...data];
  },
  SET_ORGANISATION_FLOWS_META(state, data) {
    state.flowsMeta = data;
  },
  INCREMENT_TOTAL_FLOWS(state) {
    state.flowsMeta.total += 1;
    state.flowsMeta = { ...state.flowsMeta };
  },
  ADD_FLOW(state, data) {
    state.flows.push(data.flow_data);
  },
  DELETE_FLOW(state, flowId) {
    state.flows = state.flows.filter(flow => flow.flow_id !== flowId);
    if (state.flowsMeta.total) {
      state.flowsMeta.total -= 1;
    }
    state.flowsMeta = { ...state.flowsMeta };
  },
  SET_FLOW_DATA(state, data) {
    state.flowData = data;
  },
  CLEAR_FLOWS(state) {
    state.flows = [];
    state.flowsMeta = {};
  },
  UPDATE_FLOW_DATA(state, data) {
    state.flowData = data;
    state.updatingFlow = false;
  },
  TEMP_FLOW_DATA(state, data) {
    state.updatingFlow = true;
    state.flowData.blocks = data;
  },
  BACKUP_FLOW_DATA(state) {
    state.flowDataBackup = JSON.parse(JSON.stringify(state.flowData));
  },
  ERROR_UPDATING_FLOW(state, data) {
    state.flowData = JSON.parse(JSON.stringify(state.flowDataBackup));
    state.errorUpdatingFlow = data;
    state.updatingFlow = false;
  },
  SET_SPLIT_BLOCKS_COUNT(state, payload) {
    state.blocksCount = payload;
  },
  SET_TOGGLE_ELEMENT(state, payload) {
    state.toggleElement[payload.name] = payload.state;
  },
  REMOVE_TOGGLE_ELEMENT(state, name) {
    delete state.toggleElement[name];
    state.toggleElement = { ...state.toggleElement };
  },
  CLEAR_TOGGLE_ELEMENTS(state) {
    state.toggleElement = {};
  },
};
